/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_CancelInputs */

const en_delivery_board_cancel = /** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const es_delivery_board_cancel = /** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_delivery_board_cancel = /** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_delivery_board_cancel = /** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const id_delivery_board_cancel = /** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

/** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */
const ja_delivery_board_cancel = en_delivery_board_cancel;

/** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */
const zh_delivery_board_cancel = en_delivery_board_cancel;

/** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */
const ar_delivery_board_cancel = en_delivery_board_cancel;

/** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */
const it_delivery_board_cancel = en_delivery_board_cancel;

/** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */
const ru_delivery_board_cancel = en_delivery_board_cancel;

/** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */
const pt_delivery_board_cancel = en_delivery_board_cancel;

/** @type {(inputs: Delivery_Board_CancelInputs) => LocalizedString} */
const ko_delivery_board_cancel = en_delivery_board_cancel;

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Delivery_Board_CancelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_cancel = /** @type {((inputs?: Delivery_Board_CancelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_CancelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_cancel(inputs)
	if (locale === "es") return es_delivery_board_cancel(inputs)
	if (locale === "fr") return fr_delivery_board_cancel(inputs)
	if (locale === "de") return de_delivery_board_cancel(inputs)
	if (locale === "ja") return ja_delivery_board_cancel(inputs)
	if (locale === "zh") return zh_delivery_board_cancel(inputs)
	if (locale === "ar") return ar_delivery_board_cancel(inputs)
	if (locale === "id") return id_delivery_board_cancel(inputs)
	if (locale === "it") return it_delivery_board_cancel(inputs)
	if (locale === "ru") return ru_delivery_board_cancel(inputs)
	if (locale === "pt") return pt_delivery_board_cancel(inputs)
	return ko_delivery_board_cancel(inputs)
});